<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <svg
    ref="svg"
    :viewBox="icon.viewBox"
    :class="classes"
    v-html="icon.html"
  ></svg>
</template>

<script>
import {
  ref,
  toRefs,
  watch,
  getCurrentInstance,
} from 'vue';

const ICON_ALIASES = {
  address: 'address-dropmark',
  auto_increment: 'auto-increment',
  boolean: 'check-box',
  connection: 'database-lookup',
  date_time: 'date-time',
  file: 'attach-file',
  min: 'sigma',
  max: 'sigma',
  average: 'sigma',
  sum: 'sigma',
  count: 'sigma',
  multiple_choice: 'radio-button-checked',
  paragraph_text: 'paragraph-text',
  password: 'key',
  rating: 'rating-star',
  rich_text: 'rich-text',
  short_text: 'short-text',
  concatenation: 'text-formula',
  user_roles: 'users',
};

export default {
  name: 'Icon',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { type } = toRefs(props);

    const icon = ref({});
    const classes = ref(['icon', props.class]);
    const svg = ref(null);

    const loadSpriteData = () => {
      const iconType = ICON_ALIASES[type.value] || type.value;

      const iconData = require(`@/assets/svgs/${iconType}.svg`).default;

      classes.value = [
        'icon',
        `icon-${iconType}`,
        props.class,
      ];

      icon.value.html = iconData.html;
      icon.value.viewBox = iconData.viewBox;
    };

    loadSpriteData();

    watch(type, loadSpriteData);

    const instance = getCurrentInstance();
    if (instance) {
      instance.exposeProxy = { svg };
    }

    return {
      classes,
      icon,
      svg,
    };
  },
};

</script>
